<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 48H48V0H0V48ZM6.858 41.1419H41.142V6.8549H6.858V41.1419ZM39.822 30.855V23.472L24 17.142L8.178 23.472V30.855L24 24.528L39.822 30.855Z" fill="#EC520D"/>
</svg>
